import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { CampaignListPage } from '@/features/marketing-shared/ui/campaign-list-page';
import type { MarketingCampaignRow } from '@/features/marketing-shared/model/campaign-filters';
import { useChannelQuotas } from '@/features/channel-quota/model/use-channel-quotas';
import { usePassbook } from '@/shared/lib/passbook';
import { CapacityBanner } from '@/features/marketing-shared';
import { CampaignActions } from './campaign-actions';
import { useEmailMarketing } from '../model/context';
import { useEmailMarketingPaths } from '../model/paths';

export function EmailCampaignsPage() {
  const navigate = useNavigate();
  const { idPassbook } = usePassbook();
  const { campaigns, campaignsState } = useEmailMarketing();
  const { quotas, live } = useChannelQuotas(idPassbook);
  const paths = useEmailMarketingPaths();
  const rows = useMemo<MarketingCampaignRow[]>(
    () =>
      campaigns.map((campaign) => ({
        id: campaign.id,
        name: campaign.name,
        status: campaign.status,
        audienceName: campaign.audience.audienceName,
        eligible: campaign.audience.eligible,
        scheduledAt: campaign.scheduledAt,
        createdAt: campaign.createdAt,
        sendMode: campaign.sendMode,
        sent: campaign.metrics?.sent,
      })),
    [campaigns],
  );

  return (
    <CampaignListPage
      title="E-mail"
      icon={Mail}
      phase={campaignsState.phase}
      error={campaignsState.error}
      onRetry={campaignsState.refetch}
      loadingLabel="Carregando campanhas de e-mail"
      errorTitle="Não foi possível carregar as campanhas"
      rows={rows}
      emptyTitle="Nenhuma campanha de e-mail"
      emptyDescription="Crie a primeira: escolha o público, o modelo e aprove o agendamento. O envio sai pela agenda do FixeCRM."
      selectAllId="select-all-email-campaigns"
      banner={quotas ? <CapacityBanner capacity={quotas.email} channel="email" live={live} /> : null}
      onCreate={() => navigate(paths.create)}
      onOpen={(row) => navigate(paths.detail(row.id))}
      renderActions={(row) => <CampaignActions campaign={{ id: row.id, name: row.name, status: row.status }} />}
    />
  );
}
